import dayjs from 'dayjs';

import { Campaign } from '@/models/campaign';
import { ResponseCandidate } from '@/models/response_candidate';
import { RumConfig } from '@/models/rum_config';

const staging = new Campaign({
  campaignUuid: 'f964060b-d385-4b23-a65f-692358e76668',
  campaignStartUts: dayjs.tz('2000-01-01 00:00:00', 'Asia/Tokyo'),
  campaignEndUts: dayjs.tz('2100-01-01 00:00:00', 'Asia/Tokyo'),
  liffId: '2004571064-peNEm6WN',
  clientBasicId: '@489jxypd',
  isOnlyOpenid: true,
  googleTagManagerIds: [], // 本番はいる
  escapeUrl: 'https://ora2campaign2406.com', // TODO: 設定する 用意してもらったLPのURL
  responseCandidates: [

    // TODO: 設定する
    // 11個入る
    // OCR_OK -> OK用のページ
    // OCR_NG -> NG用のページ
    new ResponseCandidate({
      name: 'OCR_OK_1',
      uuid: '6b1d2d04-82b3-4fcf-a7d7-afc879408d29',
      pageName: 'entry-completed', // 表示させたいページのパス(CMS)
    }),
    new ResponseCandidate({
      name: 'OCR_OK_2',
      uuid: '31a25233-6acb-4812-a704-ba178906e685',
      pageName: 'entry-completed', // 表示させたいページのパス(CMS)
    }),
    new ResponseCandidate({
      name: 'OCR_OK_3',
      uuid: '791ab450-57d8-4102-8e35-7e50aebc37cf',
      pageName: 'entry-completed', // 表示させたいページのパス(CMS)
    }),
    new ResponseCandidate({
      name: 'OCR_OK_4',
      uuid: '896fa14a-dd53-458b-bdac-1b0b0d992bd2',
      pageName: 'entry-completed', // 表示させたいページのパス(CMS)
    }),
    new ResponseCandidate({
      name: 'OCR_OK_5',
      uuid: 'f78e2805-887e-4b32-8e22-0e592600024e',
      pageName: 'entry-completed', // 表示させたいページのパス(CMS)
    }),
    new ResponseCandidate({
      name: 'OCR_OK_6',
      uuid: 'f706a584-1bcb-4ee5-a665-9e940e31cc40',
      pageName: 'entry-completed', // 表示させたいページのパス(CMS)
    }),
    new ResponseCandidate({
      name: 'OCR_OK_7',
      uuid: '370e0adb-daae-4fca-bc73-b86750277d5c',
      pageName: 'entry-completed', // 表示させたいページのパス(CMS)
    }),
    new ResponseCandidate({
      name: 'OCR_OK_8',
      uuid: 'b342fa1f-c4d2-4c59-ae84-954bb8dee602',
      pageName: 'entry-completed', // 表示させたいページのパス(CMS)
    }),
    new ResponseCandidate({
      name: 'OCR_OK_9',
      uuid: '09fda181-11c6-4bb1-b6ed-bc4fb6ffb96f',
      pageName: 'entry-completed', // 表示させたいページのパス(CMS)
    }),
    new ResponseCandidate({
      name: 'OCR_OK_10',
      uuid: '43fc32a8-192a-4610-96e1-27384c024b4a',
      pageName: 'entry-completed', // 表示させたいページのパス(CMS)
    }),
    new ResponseCandidate({
      name: 'OCR_NG',
      uuid: '1fc1b89e-c6c8-4b37-a00e-2fe8ee77ac5a',
      pageName: 'entry-uncompleted', // 表示させたいページのパス(CMS)
    }),
    new ResponseCandidate({
      name: '該当なし',
      uuid: '6db1c83b-a6c1-4d35-9876-030fad11cc41',
      pageName: 'error',
    }),
    new ResponseCandidate({
      name: 'アンケート未回答',
      uuid: 'd7965117-5587-4c7d-9bd1-6a515828ef8e',
      pageName: 'error',
    }),
    new ResponseCandidate({
      name: 'アンケート重複回答',
      uuid: '3ef8c3f1-aa01-49ba-b8a3-e5eca1a88cb3',
      pageName: 'error',
    }),
  ],

  // 使わない
  // TODO: liff.sendMessage を利用する場合には記述する
  // liffSendMessages: [
  //   {
  //     type: 'text',
  //     text: 'receiptUuid: <%= insertDataStore.receiptUuid.value %>',
  //   },
  // ],
});

const prod = new Campaign({
  campaignUuid: '6bffa990-5bb1-458b-b933-a04e8090fae6',
  campaignStartUts: dayjs.tz('2024-06-21 00:00:00', 'Asia/Tokyo'), // 動作確認用日付、最終確認時に修正
  campaignEndUts: dayjs.tz('2024-09-08 00:00:00', 'Asia/Tokyo'),
  liffId: '2005466699-P1ZxrdJ6',
  clientBasicId: '@816prpom',
  isOnlyOpenid: true,
  googleTagManagerIds: ['GTM-TS3LXGHS'],
  escapeUrl: 'https://ora2campaign2406.com',
  responseCandidates: [
    new ResponseCandidate({
      uuid: '1f259698-1ae2-4c5e-bc71-7aa3b9d3501b',
      name: 'OCR_OK_ルビー（日常編）',
      pageName: 'entry-completed',
    }),
    new ResponseCandidate({
      uuid: '2e3b14ec-1548-457a-9ba7-c42a8ac477f5',
      name: 'OCR_OK_ルビー（プレミアム編）',
      pageName: 'entry-completed',
    }),
    new ResponseCandidate({
      uuid: 'c442f938-2bb7-465d-8789-debcb9c15f5b',
      name: 'OCR_OK_有馬かな（日常編）',
      pageName: 'entry-completed',
    }),
    new ResponseCandidate({
      uuid: '2618c3f9-fa29-4ca5-924f-c46b81df31c1',
      name: 'OCR_OK_有馬かな（プレミアム編）',
      pageName: 'entry-completed',
    }),
    new ResponseCandidate({
      uuid: '7738b7cc-9c47-4c14-94a4-0b0fcb6331d2',
      name: 'OCR_OK_MEMちょ（日常編）',
      pageName: 'entry-completed',
    }),
    new ResponseCandidate({
      uuid: '501ebf1c-bcec-4c7c-af1c-99b22b660573',
      name: 'OCR_OK_MEMちょ（プレミアム編）',
      pageName: 'entry-completed',
    }),
    new ResponseCandidate({
      uuid: '641b7806-e37d-46d7-9a51-eaf611547728',
      name: 'OCR_OK_B小町（日常編）',
      pageName: 'entry-completed',
    }),
    new ResponseCandidate({
      uuid: '56344630-9c85-4927-ab78-57b5c85a9cc7',
      name: 'OCR_OK_B小町（プレミアム編）',
      pageName: 'entry-completed',
    }),
    new ResponseCandidate({
      uuid: '4147faf5-539d-4dd0-a6e2-eb91f34cd91a',
      name: 'OCR_OK_アクア',
      pageName: 'entry-completed',
    }),
    new ResponseCandidate({
      uuid: 'e9587c33-6736-472b-b2c9-9115a1569c28',
      name: 'OCR_OK_黒川あかね',
      pageName: 'entry-completed',
    }),
    new ResponseCandidate({
      uuid: '9f0079a4-b2cd-4084-a493-d185df5e3f35',
      name: 'OCR_NG',
      pageName: 'entry-uncompleted',
    }),
    new ResponseCandidate({
      uuid: '0b858f50-a26e-4c59-8942-d455f0e1855a',
      name: '該当無し',
      pageName: 'error',
    }),
    new ResponseCandidate({
      uuid: 'bc8f5777-8da8-4117-bfd1-aaccca087419',
      name: 'アンケート未回答',
      pageName: 'error',
    }),
    new ResponseCandidate({
      uuid: '1e0ce1a2-150d-4bd9-872a-e3743efafae6',
      name: 'アンケート重複回答',
      pageName: 'error',
    }),
  ],

  // TODO: RUM を新規作成し「設定 > JavaScript スニペット」を参照して、必要な値を以下に貼り付ける
  // 本番環境では必ず設定する
  rumConfig: new RumConfig({
    applicationId: '3056de1d-4f5f-40f7-b78a-85cc4dc28022',
    identityPoolId: 'ap-northeast-1:b567df95-2b44-4de2-856e-16eaafbf5c6c',
  }),
});

export const campaignSettings = (() => {
  switch (process.env.VUE_APP_ENV) {
  case 'staging': return staging;
  case 'prod': return prod;
  default: return staging;
  }
})();
